import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'b', 'i', 'u', 's', 'strong', 'em', 'p', 'br', 'ul', 'ol', 'li',
  'span', 'mark', 'div',
];

const ALLOWED_ATTR = ['class', 'style'];

/**
 * Normalizes work-item rich text to the small formatting subset the editor supports.
 */
export function sanitizeRichHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form'],
  });
}
